/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { useTheme } from '@providers/theme';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { Header, UsersListComp } from '../components';

import { vappContainer } from '@/application';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { useSMPolicyList, useSMActual } from '@pages/ActualPage/machines';
import { ActualPageService } from '@pages/ActualPage/services';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import toast from 'react-hot-toast';
import { SearchFilter } from '../../../widgets/filter-widget-react';

const getSrv = () => {
  return vappContainer.get<ActualPageService>(ActualPageService.displayName);
};

export const ContainerComm = (props: any) => {
  console.log('props', props);
  const theme = useTheme();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [refreshPagination, setRefreshPagination] = useState(new Date());
  const srv = getSrv();

  useEffect(() => {
    //srv?.resetCriteria();
  }, []);

  const { actualPageMachine, actualPageSend, actualPageState } = useSMActual(
    {}
  );

  const { policyListMachine, policyListSend, policyListState } =
    useSMPolicyList({});

  console.log('render page', actualPageState?.event?.data?.value);

  const onRefresh = () => {
    actualPageSend('TRIGGER_REFRESH', {});
    setRefreshPagination(new Date());
  };

  const onClearFilter = () => {
    // srv?.resetCriteria();
    Array.from(document.querySelectorAll('input')).forEach(
      (input) => (input.value = '')
    );
    actualPageSend('TRIGGER_REFRESH', {});
  };

  const onPaginationChange = (event: any) => {
    actualPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const _renderPagination = () => {
    if (!actualPageState?.event?.data?.value?.isEmpty) {
      return (
        <Paginate
          {...(actualPageState?.event?.data?.value || {})}
          onPageChange={onPaginationChange}
          key={refreshPagination}
          totalItems={actualPageState?.event?.data?.value?.ultUsers?.length}
        />
      );
    }
  };

  const onApplyFilter = (data: any) => {
    console.log('apply clicked', data);
    let criteria: any = [];
    criteria =
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any) => {
        return {
          column: item?.filters?.inputData?.id,
          op: item?.filters?.inputData?.label,
          value: [item?.filters[item?.filters?.inputData?.label]],
        };
      });
    actualPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };

  const _renderActualPolicy = () => {
    if (actualPageState?.matches('GET_ACTUAL_POLICY')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingActualSync()?.loading
            ?.retrieveCredentials || {})}
        />
      );
    }

    if (actualPageState?.matches('RENDER_ACTUAL_POLICY')) {
      return (
        <>
          {actualPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(srv?.agent?.getLoadingActualSync()?.loading
                ?.credentialListEmpty || {})}
            />
          ) : (
            <UsersListComp
              {...(actualPageState?.event?.data?.value || {})}
              onViewDetailClick={props?.onViewDetailClick}
              onRowClick={props?.onViewDetailClick}
            />
          )}
        </>
      );
    }
    return null;
  };

  const _renderErrorModals = () => {
    if (actualPageState?.matches('RENDER_ACTUAL_POLICY_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getErrorActualSync()?.error?.formSubmit || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const _renderHeader = () => {
    if (srv?.agent?.getHeaderActualSync()?.header) {
      return (
        <>
          <Header
            {...(srv?.agent?.getHeaderActualSync()?.header || {})}
            onRefreshClick={onRefresh}
            csvData={policyListState?.event?.data?.value?.ultUsers}
          />
          <SearchFilter
            {...(srv?.agent?.getSettingsActualSync()?.settings || {})}
            onFilterApply={onApplyFilter}
            onClearFilter={onClearFilter}
          />
        </>
      );
    }
    return null;
  };

  const _renderPage = () => {
    return (
      <>
        {_renderHeader()}
        {_renderActualPolicy()}
        {_renderPagination()}
        {_renderErrorModals()}
      </>
    );
  };
  return <>{_renderPage()}</>;
};
